module.exports = __webpack_public_path__ + "img/آکاردئونی.7d1e2eb0.png";